/* Minimal theme JS: mobile nav toggle + product gallery + variant selection. */

(function () {
  'use strict';

  /* Mobile nav ---------------------------------------------------------- */
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Search overlay ------------------------------------------------------ */
  var searchBar = document.querySelector('[data-searchbar]');
  var searchOpen = document.querySelector('[data-search-open]');
  var searchClose = document.querySelector('[data-search-close]');
  var searchField = document.querySelector('[data-search-field]');

  function setSearch(open) {
    if (!searchBar) return;
    searchBar.hidden = !open;
    if (searchOpen) searchOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && searchField) searchField.focus();
  }

  if (searchOpen) {
    searchOpen.addEventListener('click', function () {
      setSearch(searchBar.hidden);
    });
  }
  if (searchClose) {
    searchClose.addEventListener('click', function () {
      setSearch(false);
      if (searchOpen) searchOpen.focus();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchBar && !searchBar.hidden) {
      setSearch(false);
      if (searchOpen) searchOpen.focus();
    }
  });

  /* Product gallery ----------------------------------------------------- */
  var main = document.querySelector('[data-main-image]');
  var thumbs = document.querySelectorAll('[data-thumb]');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (main) main.src = thumb.dataset.full || thumb.src;
    });
  });

  /* Variant selection --------------------------------------------------- */
  var form = document.querySelector('[data-product-form]');
  if (!form) return;

  var variantData = document.querySelector('[data-variant-json]');
  if (!variantData) return;

  var variants;
  try {
    variants = JSON.parse(variantData.textContent);
  } catch (e) {
    return;
  }

  var selects = form.querySelectorAll('[data-option-index]');
  var idInput = form.querySelector('[name="id"]');
  var priceEl = document.querySelector('[data-price]');
  var submit = form.querySelector('[type="submit"]');

  function currentOptions() {
    return Array.prototype.map.call(selects, function (s) { return s.value; });
  }

  function update() {
    var chosen = currentOptions();

    var match = variants.filter(function (v) {
      return chosen.every(function (val, i) { return v.options[i] === val; });
    })[0];

    if (!match) {
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Unavailable';
      }
      return;
    }

    if (idInput) idInput.value = match.id;

    if (priceEl && match.price != null) {
      priceEl.textContent = '$' + (match.price / 100).toFixed(2);
    }

    if (submit) {
      submit.disabled = !match.available;
      submit.textContent = match.available ? 'Add to cart' : 'Sold out';
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', update); });
  update();
})();
